import galleries from "./galleries.json";

export { galleries };

export function getGalleryById(countryCode) {
  if (!countryCode) return null;
  return galleries.find((gallery) => gallery.countryCode === countryCode) ?? null;
}

export function getGalleryImages(countryCode) {
  return getGalleryById(countryCode)?.images ?? [];
}
